import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

class TermListingApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async ExportCourseDetails(termCampusId: number, weekDayId: number, type: string, reportType:string = 'Excel') {
        const postObj = {
            termCampusId,
            weekDayId,
            type,
            reportType,
        };

        const { data } = await this.httpClient.post('/course-details/export', postObj, { responseType: 'arraybuffer' });
        return data;
    }

    async UpdateSectionComment(courseDetailsRow: any) {
        await this.httpClient.put('/course-details', courseDetailsRow);
    }

    async GetGENRList(termCampusId: number) {
        const postObj = {
            termCampusId,
        };
        const { data } = await this.httpClient.post('/course-details/genr', postObj);

        return data;
    }

    async GetTermListing(termType: string, termId: number, course?: string, crn?: number, weekDayId?: number, scheduleType?: any, buildingId?: number, roomTypeId?: number, instructor?: string, room?: string) {
        let url = `/course-details/search`;

        const body = {
            termType,
            termId,
            course,
            weekDayId,
            type: scheduleType?.value,
            crn,
            buildingId,
            roomTypeId,
            instructor,
            room
        }

        const { data } = await this.httpClient.post(url, body);

        return data;
    }
}

export default TermListingApi;
